import React, { useCallback } from "react";
import CreateInstanceForm from "../form/CreateInstanceForm";
import useCreateInstance from "./useCreateInstance";
import { useTranslation } from "react-i18next";
import APP_ROUTES from "src/routes/routes";
import { useSearchParams } from "react-router-dom";

export const FORM_NAME = {
  NAME: "name",
  DESCRIPTION: "description",
  MISSION_DATABASE: "mdb_s3_key",
  DASHBOARD_OPI: "opi_s3_key",
};

const NewInstance = () => {
  const { t } = useTranslation("project-instance");
  const { submitData } = useCreateInstance();
  let [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const condition = searchParams.get("condition");

  const getRedirectURL = useCallback(() => {
    const params = new URLSearchParams();

    if (page) params.set("page", page);
    if (condition) params.set("condition", condition);

    const queryString = params.toString();
    return `${APP_ROUTES.PROJECT_INSTANCE}${queryString ? "?" + queryString : ""}`;
  }, [page, condition]);

  const data = {
    [FORM_NAME.NAME]: "",
    [FORM_NAME.DESCRIPTION]: "",
    [FORM_NAME.MISSION_DATABASE]: [],
    [FORM_NAME.DASHBOARD_OPI]: [],
  };

  return <CreateInstanceForm submitData={submitData} data={data} title={t("new.title")} getRedirectURL={getRedirectURL} />;
};

export default NewInstance;
